import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { ReportResultRefresh } from '../report-result-refresh';
import { ComparativeLiteraturePublicityService, NoveltyCheckReportTitleService, NoveltyReviewService, RetrievalResultReportSubtitleInfoService, TechFeaturesService } from '../retrieval-result-report-service';
import { ComplexRetrievalService } from '../complex-retrieval-service';
import { NoveltyCheckTaskStep } from '../../enums';
import { NoveltyCheckTaskStatusService } from '../task-status-service';
import { NoveltyCheckTaskStatusModel } from '../../models/novelty-check-task-status-model';
import { SummaryTechFeaturesService } from '../summary-tech-features-service';

@injectable()
export class ReportResultRefreshImpl implements ReportResultRefresh {
    // eslint-disable-next-line max-params
    constructor(
        @inject(SummaryTechFeaturesService)
        private readonly _summaryTechFeatureService: SummaryTechFeaturesService,
        @inject(NoveltyCheckReportTitleService)
        private readonly _noveltyCheckReportTitleService: NoveltyCheckReportTitleService,
        @inject(RetrievalResultReportSubtitleInfoService)
        private readonly _retrievalResultReportSubtitleInfoService: RetrievalResultReportSubtitleInfoService,
        @inject(TechFeaturesService)
        private readonly _techFeaturesService: TechFeaturesService,
        @inject(ComplexRetrievalService)
        private readonly _complexRetrievalService: ComplexRetrievalService,
        @inject(ComparativeLiteraturePublicityService)
        private readonly _comparativeLiteraturePublicityService: ComparativeLiteraturePublicityService,
        @inject(NoveltyReviewService)
        private readonly _noveltyReviewService: NoveltyReviewService,
        @inject(NoveltyCheckTaskStatusService)
        private readonly _noveltyCheckTaskStatusService: NoveltyCheckTaskStatusService,
        @inject(NoveltyCheckTaskStatusModel)
        private readonly _noveltyCheckTaskStatusModel: NoveltyCheckTaskStatusModel,
    ) { }

    async refresh(isNeedUpdateTaskStatus: boolean = true): Promise<void> {
        if (this._noveltyCheckTaskStatusModel.modelData.taskStep === NoveltyCheckTaskStep.SEARCH_FINISHED && this._noveltyCheckTaskStatusService.serverSideTaskStep !== NoveltyCheckTaskStep.REPORT_CREATED) {
            // 获取搜索结果
            await this._complexRetrievalService.search();
            return;
        }

        Promise.all([
            // 获取新颖性报告名称
            this._noveltyCheckReportTitleService.pullNoveltyCheckReportTitle(),
            // 获取检索结果报告副标题信息
            this._retrievalResultReportSubtitleInfoService.pullRetrievalResultReportSubtitleInfo(),
            // 获取技术特征
            this._techFeaturesService.pullTechFeatures(),
            // 获取搜索结果
            this._complexRetrievalService.search(),
        ]);
        // 获取新颖性评述
        await this._noveltyReviewService.pullNoveltyReview();
        // 获取对比文献公开情况, 这个接口在后端也会获取新颖性评述,所以这里先等上面获取完再获取,可以利用缓存防止评述结果和公开情况不一致
        await this._comparativeLiteraturePublicityService.pullComparativeLiteraturePublicity();
        // 更新任务状态
        if (isNeedUpdateTaskStatus) {
            await this._noveltyCheckTaskStatusService.pullTaskStatus();
        }
    }
}
